import Swiper, {Autoplay} from 'swiper';
import { osHasReducedMotion } from '../util/a11y';

Swiper.use([Autoplay]);

export default function(selector = '.js-swiper-vertical') {

  function initSwiper(element, settings){

    let defaultSettings = {
      direction: 'vertical',
      loop: true,
      loopedSlides: null,
      slidesPerView: 'auto',
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
      },
      speed: 5000,
    }

    let parameters = {
      ...defaultSettings,
      ...settings,
    }

    // A11Y: Reduce Motion for Swiper Autoplay
    if ( osHasReducedMotion() ) {
      delete parameters.autoplay;
      delete parameters.speed;
    }

    return new Swiper(element, parameters);
  }

  document.querySelectorAll(selector).forEach((element) => {
    let settings = element.getAttribute('data-swiper') || {};
    settings = JSON.parse(settings);
    initSwiper(element, settings);
  });
}
